/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CarTechDtoFromJSON(json) {
    return CarTechDtoFromJSONTyped(json, false);
}
export function CarTechDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'engineCapacity': !exists(json, 'engineCapacity') ? undefined : json['engineCapacity'],
        'acceleration': !exists(json, 'acceleration') ? undefined : json['acceleration'],
        'maxSpeed': !exists(json, 'maxSpeed') ? undefined : json['maxSpeed'],
        'mass': !exists(json, 'mass') ? undefined : json['mass'],
    };
}
export function CarTechDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enginePower': value.enginePower,
        'engineCapacity': value.engineCapacity,
        'acceleration': value.acceleration,
        'maxSpeed': value.maxSpeed,
        'mass': value.mass,
    };
}
